import { render, staticRenderFns } from "./set-timeout.vue?vue&type=template&id=53a2543b&scoped=true"
import script from "./set-timeout.vue?vue&type=script&lang=js"
export * from "./set-timeout.vue?vue&type=script&lang=js"
import style0 from "./set-timeout.vue?vue&type=style&index=0&id=53a2543b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2543b",
  null
  
)

export default component.exports